import React, { useEffect, useState } from 'react'; 
import Sidebar from './Sidebar'; 
import axios from 'axios';
import { BASE_URL, BASE_PAYMENT_URL } from './../../Environment';
import { toast } from 'react-toastify';
import Info from './Info';
import { Link } from 'react-router-dom';
import { FaImage, FaPen, FaTrash } from 'react-icons/fa';
import { format } from 'date-fns';

function Listing() {
    const accessToken = localStorage.getItem('accessToken');
    const [isLoading, setIsLoading] = useState(false);
    const [listing, setListing] = useState([]);
    function onGetData() {
        setIsLoading(true);
        axios.get(`${BASE_URL}/vendor/listing`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {
            setListing(res.data.data);
            setIsLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        });
    }
    useEffect(() => {
        document.title = 'Infomart | Client Listing';
        onGetData();
    }, []);
    const onListingRenew = async (id) => {
        axios.post(`${BASE_URL}/vendor/listing/payment`, { id }, {
            headers: {  
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {
            if (res.data.encrypted_data && res.data.access_code) { 
                const form = document.createElement('form');
                form.method = 'post';
                form.action = BASE_PAYMENT_URL; 
                const encRequestInput = document.createElement('input');
                encRequestInput.type = 'hidden';
                encRequestInput.name = 'encRequest';
                encRequestInput.id = 'encRequest';
                encRequestInput.value = res.data.encrypted_data;
                form.appendChild(encRequestInput); 
                const accessCodeInput = document.createElement('input');
                accessCodeInput.type = 'hidden';
                accessCodeInput.name = 'access_code';
                accessCodeInput.id = 'access_code';
                accessCodeInput.value = res.data.access_code;
                form.appendChild(accessCodeInput); 
                document.body.appendChild(form); 
                form.submit(); 
            }   
        }).catch((res) => {  
            toast.error(res.response.data.msg, { autoClose: 3000 }); 
        }); 
    } 
    const onDeleteData = async (id) => {
        const confirmed = window.confirm('Are you sure you want to delete this data?');
        if (confirmed) {
            await axios.post(`${BASE_URL}/vendor/listing/delete`, { id }, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}` 
                } 
            }).then((res) => {
                toast.success(res.data.msg, { autoClose: 3000 });
                onGetData();
            }).catch((res) => {
                toast.error(res.response.data.msg, { autoClose: 3000 });
            });
        } 
    }
    return (
        <div className="app"> 
            <div className="outlet">
                <Info />
                <div className="homeLayout">
                    <Sidebar />
                    {isLoading ? 
                        <h5 className="text-center mt-5">Loading...</h5>
                    : 
                        <div className="card">
                            <div className="card-header fw-bold " style={{whiteSpace:'nowrap'}}>
                                Your Business Listing
                                <Link to="/client/listing/create" className="float-end text-decoration-none">New Listing</Link>
                            </div>   
                            {/* <div className="card-body"> */}
                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th scope="col">#</th> 
                                            <th scope="col" width="15%">Listing Name</th>
                                            <th scope="col">Location</th> 
                                            <th scope="col" width="15%">Phone No.</th> 
                                            <th scope="col" width="15%">WhatsApp No.</th>
                                            <th scope="col" width="12%">Expiry Date</th> 
                                            <th scope="col">Status</th>
                                            <th scope="col" width="15%">Action</th>
                                        </tr>  
                                    </thead>
                                    <tbody className="align-middle">
                                        {listing && listing.length > 0 ? (
                                            listing.map((data, i) => { 
                                                const today = new Date();
                                                const expiryDate = new Date(data.expiry_date);
                                                today.setHours(0, 0, 0, 0); 
                                                const isExpired = expiryDate < today; 
                                                return (
                                                    <tr key={i}>
                                                        <th scope="row">{i + 1}</th>
                                                        <td>{data.name}</td>
                                                        <td>{data.district}</td> 
                                                        <td>+91 {data.phone}</td>
                                                        <td>+91 {data.whatsapp}</td>
                                                        <td>
                                                            {isExpired || data.status == 'Inactive' ? 
                                                                <Link className="text-danger fw-bold text-decoration-none" onClick={() => onListingRenew(data.id)}>Upgrade</Link>  
                                                            :      
                                                                <span>{format(expiryDate, 'dd MMM, yyyy')}</span> 
                                                            }    
                                                        </td>
                                                        <td>
                                                            {data.status === 'Active' ?
                                                                <span className="badge bg-success">{data.status}</span>
                                                            :
                                                                <span className="badge bg-danger">{data.status}</span>
                                                            } 
                                                        </td>
                                                        <td className="text-center"> 
                                                            <Link to={'/client/listing/' + data.id + '/image'} className="btn btn-success btn-sm">Image</Link>
                                                            <Link to={'/client/listing/' + data.id + '/update'} className="btn btn-primary btn-sm ms-1">Update</Link>
                                                            <button className="btn btn-danger btn-sm ms-1" onClick={() => onDeleteData(data.id)}><FaTrash /></button>  
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <th colSpan="8" className="text-center">No data available.</th>
                                            </tr> 
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    }
                </div>
            </div> 
        </div>
    );
}

export default Listing;           